import React, { useEffect, useState } from 'react'
import Icon from 'components/Icon'
import VoiceCompact from 'components/VoiceCompact'
import classNames from 'classnames'
import { FormattedMessage, FormattedList, useIntl } from 'react-intl'
import messages from './messages'
import { Button, Banner, Card, TextArea } from '@arnsbogroup/react-voicearchive'
import useOpenAi from 'hooks/useOpenAi'

const AiVoiceSuggestDrawer = ({ isExpanded, onClose, onSuggestion }) => {
  const [expanded, setExpanded] = useState(false)
  const [form, setForm] = useState({
    script: '',
  });
  const [openAiState, voiceSuggest] = useOpenAi()
  const [errors, setErrors] = useState()

  useEffect(() => {
    setExpanded(isExpanded)
  }, [isExpanded]);

  async function onAiSuggest () {
    setErrors(undefined);
    const suggestion = await voiceSuggest(form.script);

    if (suggestion.tone || suggestion.category) {
      onSuggestion(suggestion);
    } else {
      setErrors("The script does not convey a tone or category. Please try again.");
    }
  }

  const { formatMessage } = useIntl()

  return (
    <div
      className={classNames(
        expanded
          ? ['z-50', 'md:w-1/4', 'h-auto']
          : ['w-full md:w-0', 'h-0 md:h-full'],
        [
          'bg-neutral-50',
          'border-gray-300',
          'border-t',
          'bottom-0',
          'delay-150',
          'ease-in-out',
          'fixed',
          'flex',
          'flex-col',
          'max-h-full',
          'md:border-l',
          'md:right-0',
          'md:top-0',
          'overflow-hidden',
          'overflow-hidden',
          'shadow-lg',
          'transition-all',
          'w-full',
        ]
      )}
    >
      <div
        className={classNames(
          'md:flex-grow p-4 space-y-4',
          expanded ? 'block' : 'hidden md:block'
        )}
      >
        <div className="flex items-center justify-between">
          <p className="text-sm">
            <b className="font-bold"><FormattedMessage {...messages.callToAction}/></b>
          </p>


          <Button
            variant="inline"
            className="px-1 text-sm hover:text-negative"
            onClick={() => {
              onClose()
            }}
            icon="times"
            iconPosition="right"
          >
              <FormattedMessage {...messages.close} />
          </Button>
        </div>
          <ul className="list-decimal text-sm pl-4 space-y-2">
              <FormattedMessage {...messages.usageInstructions} values={{
                  item: chunks => <item>{chunks}</item>,
              }}/>

          </ul>

          {errors && (
            <Banner state="error" subtitle={errors} />
          )}

          <TextArea
            className="text-sm"
            placeholder={formatMessage(messages.bestExperiencesPrompt)}
            rows={8}
            value={form.script}
            disabled={openAiState.isLoading}
            onChange={(e) => {
              setForm({ ...form, script: e.target.value });
            }}
          />

          <p className="text-xs text-grayscale-lighter">
              <FormattedMessage {...messages.feedback} values={{
                  b: chunks => <b className='font-medium'>{chunks}</b>,
              }} /><a href={`mailto:${formatMessage(messages.betaEmail)}`}  className="border-b border-grayscale-lighter border-dashed"><FormattedMessage {...messages.betaEmail}/></a>.
          </p>
      </div>

      <div className="flex-shrink-0 p-4 space-y-2">
        <Button
          state="positive"
          className="w-full bg-positive-darker border-positive-darker"
          disabled={!form.script.length || openAiState.isLoading}
          onClick={() => onAiSuggest()}
          icon={['fas', 'search']}
          iconPosition="right"
        >
          { openAiState.isLoading ?
            <span><FormattedMessage {...messages.processing} /></span>
          :
            <span><FormattedMessage {...messages.loaded} /></span>
          }
        </Button>
      </div>

    </div>
  )
}

export default AiVoiceSuggestDrawer
